




























































import {Component, Vue} from "vue-property-decorator";
import PayrollService from "@/services/payroll/PayrollService";
import FileUpload from "@/components/common/FileUpload.vue";
import {IEmployment} from "@/dto/payroll/IEmployment";
import EmploymentService from "@/services/EmploymentService";
import EmployeeDto from "@/dto/payroll/EmployeeDto";
import {EmploymentFilter} from "@/dto/payroll/Filters";
import {EmploymentStatus} from "@/components/payroll/business/employments/contractors/Contractor";
import {processError} from "@/utils/ComponentUtils";
import PortalRadio from "@/components/v2/common/PortalRadio.vue";
import SelectOption from "@/components/common/SelectOption";
import Application from "@/state/Application";
import {PayrollReportFilter} from "@/dto/payroll/PayrollReportFilter";
import {PayrollReport} from "@/components/payroll/business/employments/employee/PayrollReport";
import CollapsedPaystubReport from "@/components/payroll/reports/paystub/CollapsedPaystubReport.vue";
import PaginationComponent from "@/components/util/PaginationComponent.vue";
import PortalDate from "@/components/common/PortalDate.vue";

@Component({
  components: {PortalDate, PaginationComponent, CollapsedPaystubReport, PortalRadio, FileUpload}
})
export default class IndividualPaystubs extends Vue {

	private selectedEmployer: IEmployment | null = null
	private employments: Array<IEmployment> = []
	get employmentOptions(): Array<SelectOption> {
		return this.employments.map(employment => new SelectOption(
			{
				title: employment.employer.name,
				value: employment
			}
		));
	}

	private filter = new PayrollReportFilter()
	private paystubs: Array<PayrollReport> = [];

	private totalPages = 0;

  mounted(){
	  Application.startLoading()
	  this.loadEmployments()
		  .then(this.initFilter)
		  .then(this.loadReports)
		  .finally(Application.stopLoading);
  }

  private loadEmployments(): Promise<void> {
	  return EmploymentService.getAllByFilter<EmployeeDto>(
		  new EmploymentFilter(
			  {
				  detailsId: this.$wss.getCurrent.id,
				  types: ["STAFF"]
			  }
		  )
	  ).then(
		  res => {
			  this.employments = res.data;
			  if (this.employments.length > 0) {
				  this.selectedEmployer = this.employments[0];
			  }
		  },
		  err => processError(err, this)
	  )
  }

	private initFilter() {
		this.filter.employeeId = this.selectedEmployer!.details.id
		this.filter.employerId = this.selectedEmployer!.employer.id
		this.filter.employmentId = this.selectedEmployer!.id
		return Promise.resolve()
	}

	private loadReports(): Promise<void> {
		return PayrollService.getPaystubPageByFilter(this.filter).then(
			(response) => {
				this.paystubs = response.data.data;
				this.totalPages = response.data.countOfPages
			},
			err => processError(err, this)
		);
	}

	private resetFilter() {
		this.filter.startDate = null
		this.filter.endDate = null;
		this.filter.page = 0;
	}

	private loadReportsForEmployment() {
	  Application.startLoading()
	  this.initFilter()
		  .then(this.loadReports)
		  .finally(Application.stopLoading)
	}

}
